import React from "react";
import ListItemComponent from "./components/listItemComponent";
import navBar from "../../configs/navBarConfig";

const NavBar = () => {
  let closed = true;
  const renderListItems = () =>
    navBar.map((navItem) => (
      <ListItemComponent navItem={navItem} key={navItem.label} clicked={toggleNav} />
    ));
  const renderBurgerIcon = () => (
    <div id="burger-icon" onClick={toggleNav}>
      <i className="fas fa-arrows-alt-h fa-2x text-primary"></i>
    </div>
  );

  const toggleNav = () => {
    if (closed && window.screen.width < 1024) {
      document.getElementById("navBar").style.left = "0";
      document.getElementById("burger-icon").style.left = "220px";

      closed = !closed;
    } else if (window.screen.width < 1024) {
      document.getElementById("navBar").style.left = "-250px";
      document.getElementById("burger-icon").style.left = "-30px";
      closed = !closed;
    } else {
      document.getElementById("navBar").removeAttribute("style");
    }
  };
  return (
    <header>
      <nav id="navBar">
        {renderBurgerIcon()}
        <ul className="list-unstyled mb-0">{renderListItems()}</ul>
      </nav>
    </header>
  );
};

export default NavBar;
